import webBiLogger from 'web-bi-logger';
import createHpLogger, {Logger as BiLoggerHp} from 'bi-logger-hp';
import initPblcSchemaLogger, {Logger as BiLoggerPblc} from 'bi-logger-pblc';

interface Loggers {
  hp: BiLoggerHp;
  pblc: BiLoggerPblc;
}

class BiLogger {
  protected loggers: Loggers = {} as any;
  protected loggerCreators = {
    hp: createHpLogger,
    pblc: initPblcSchemaLogger,
  };

  getLogger<T extends keyof Loggers>(name?: T): Loggers[T] {
    if (!this.loggers[name]) {
      if (!this.loggerCreators[name]) {
        throw new Error(`Could not find logger creator for ${name}`);
      }

      this.loggers[name] = this.loggerCreators[name](webBiLogger)({
        useBeacon: true
      });
    }

    return this.loggers[name];
  }
}

export const getOrigin = () => {
  return location.origin || `https://${location.hostname}${location.port ? `:${location.port}` : ''}`;
};

export const HP_VERSION = 'hp2018';

export const biLogger = new BiLogger();
